import type { FormProps } from '../../types'
import { useController } from 'react-hook-form'
import style from '../form.module.css'

export interface CustomDateInput {
  name: string
  type: string
  customControlType: 'dateInput'
  minDate?: Date
  maxDate?: Date
  validation?: {
    required?: boolean
    minLength?: number
    maxLength?: number
    pattern?: string
    min?: number
    max?: number
    step?: number
  }
  uiOptions?: {
    testId?: string
  }
}

export type CustomDateProps = {
  field: CustomDateInput
  formProps: FormProps
}

/**
 * BMW Brand Date Component - Native HTML5 date input
 * This replaces the DatePicker with a simple native input for BMW brand
 */
export default function CustomDate({ field, formProps }: CustomDateProps) {
  const {
    field: { onChange, value, ref },
  } = useController({
    control: formProps.control,
    name: field.name,
  })

  // Format date to YYYY-MM-DD for input[type="date"]
  const formatDate = (date?: Date | string): string => {
    if (!date) return ''
    if (typeof date === 'string') return date.substring(0, 10)
    return date.toISOString().substring(0, 10)
  }

  return (
    <div
      data-testid={field.name}
      className="date-input-container"
      ref={ref}
    >
      <input
        type="date"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        min={field.minDate ? formatDate(field.minDate) : undefined}
        max={field.maxDate ? formatDate(field.maxDate) : undefined}
        className={style.customInputDate}
      />
    </div>
  )
}
